module.exports = __webpack_public_path__ + "static/media/Gain.9a9153fd.svg";